import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";
import DriversPowerSelect from '../drivers/drivers-power-select.jsx';

export default class DailyJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getInvoicedReportUrl:'/api/v1/portal/portal-admin/daily-jobs-report',
            DailyJobsReportData:[],
            downloadReportName:'Daily Jobs Report',
            selectedDriver:"",
            driver_id:"",
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleDriverSelection = this.handleDriverSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
      }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleDriverSelection(selectedOption) {
        this.setState({driver_id: selectedOption.driver_id,selectedDriver:selectedOption.full_name});
    }
    handleDailyJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            driver_id: this.state.driver_id,
            selected_date:moment(this.state.startDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                DailyJobsReportData: response,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        let filenamed = filename+" "+moment(this.state.startDate).format("YYYY-MM-DD")+" "+(this.state.selectedDriver)+".csv";
        let textdata = "JOB REF,UNIT NUMBER,COMPANY,CUSTOMER,3 LITTLE WORDS,ADDRESS,POSTCODE,STATUS,REQUIRED SERVICE DATE\n"+text;
        let element = document.createElement(
        'a'
        );
        element.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' + encodeURIComponent(textdata)
        );
        element.setAttribute(
        'download',
        filenamed
        );
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    render() {
        let dailyJobs = [];
        let downloadableCsvDataInvoiced = "";
        if(this.state.DailyJobsReportData.length > 0){
            this.state.DailyJobsReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;
                dailyJobs.push(
                        <tr key={index}>
                            <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                            <td>{currentJob.unit.unit_number != null ? currentJob.unit.unit_number : ""}</td>        
                            <td>{currentJob.company.short_name}</td>
                            <td>{currentJob.customer.name}</td>
                            <td>{currentJob.three_words_of_dropoff_address}</td>
                            <td>{currentJob.dropoff_address.address_line_1}</td>        
                            <td>{currentJob.dropoff_address.postcode}</td>        
                            <td>{currentJob.status}</td>        
                            <td>{(currentJob.dropoff_day+'.'+currentJob.dropoff_month+'.'+currentJob.dropoff_year+" "+currentJob.dropoff_time.toUpperCase())}</td>        
                        </tr>
                );
                downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                        currentJob.id+','+
                                        (currentJob.unit.unit_number != null ? currentJob.unit.unit_number : "")+','+
                                        currentJob.company.short_name+','+
                                        currentJob.customer.name.replace(",", " ")+','+
                                        currentJob.three_words_of_dropoff_address+','+
                                        currentJob.dropoff_address.address_line_1+','+
                                        currentJob.dropoff_address.postcode+','+
                                        currentJob.status+','+
                                        (currentJob.dropoff_day+'.'+currentJob.dropoff_month+'.'+currentJob.dropoff_year+" "+currentJob.dropoff_time.toUpperCase())+"\n";
            });
        }else{
            dailyJobs.push(
                <tr key='no-records'><td colSpan="9" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Daily Jobs Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Driver</h5></label><br/>
                            <DriversPowerSelect
                                handleDriverSelection={this.handleDriverSelection}
                            />
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleDailyJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Daily Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.DailyJobsReportData.length} jobs found..</b></label></div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead>
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Unit Number</th>
                                        <th>Company</th>
                                        <th>Customer</th>
                                        <th>3 Little Words</th>
                                        <th>Address</th>
                                        <th>Postcode</th>
                                        <th>Status</th>
                                        <th>Required Service Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="14"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    dailyJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-daily_jobs_report')) {
    ReactDOM.render(
        <DailyJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-daily_jobs_report')
    );
}
